var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 13,
  viewBox: "0 0 13 13"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-725 -441)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(725 441)",
  fill: "#fff",
  stroke: "#36c626",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 6.5,
  r: 6.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 6.5,
  r: 6,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(728.25 445.333)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.687,5.16a.267.267,0,0,1-.045,0,.339.339,0,0,1-.249-.168L.045,2.63a.339.339,0,1,1,.588-.336L1.76,4.268,5.916.1A.339.339,0,0,1,6.4.578L1.942,5.045l-.016.016A.338.338,0,0,1,1.687,5.16Z",
  transform: "translate(0 0)",
  fill: "#36c626",
  stroke: "#36c626",
  strokeWidth: 0.5
})))));
export default __webpack_public_path__ + "static/media/check-circle.e97a96ab.svg";
export { SvgComponent as ReactComponent };